/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Popover from './Popover';
import { unstable } from '@broadleaf/admin-components';
const { useOnCaptureOutside, SVG } = unstable;

/**
 * Renders a clickable label which, when acted upon, will render a popover with
 * the provided content.
 */
const PopoverLabel = ({ children, label, position }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const onCaptureInside = useOnCaptureOutside(
    () => setIsOpen(false),
    ['mousedown', 'touchstart']
  );
  return (
    <span
      onMouseDownCapture={onCaptureInside}
      onTouchStartCapture={onCaptureInside}
    >
      <button
        className="tw-flex tw-items-center tw-border-none tw-text-sm tw-font-medium tw-text-link-600 tw-outline-none hover:tw-text-link-700 focus:tw-outline-none"
        onClick={() => setIsOpen(isOpen => !isOpen)}
        ref={triggerRef}
        type="button"
      >
        {label}
        <SVG className="tw-h-4 tw-w-4 tw-fill-current" name="cheveron-down" />
      </button>
      <Popover
        active={isOpen}
        className="tw-w-64 tw-border tw-text-gray-900"
        color="white"
        position={position}
        parent={triggerRef}
        type="popover"
      >
        {children}
      </Popover>
    </span>
  );
};

PopoverLabel.propTypes = {
  /**
   * The popover content.
   */
  children: PropTypes.node.isRequired,
  /**
   * The label content.
   */
  label: PropTypes.node.isRequired
};

export default PopoverLabel;
